import {deleteCookie} from "../lib/cookie";
export default ()=> {
    localStorage.clear();
    sessionStorage.clear();
    deleteCookie("refreshToken");
    deleteCookie("accessToken");
    window.location.replace('/');
}